jQuery(document).ready(function( $ ) {
  
var date = new Date();
var displaytime = '';
  var displaytime1='';
	
switch (date.getDay()) {
    case 0:
    	bannerDisplay('17:00', '08:00');
        break;
    case 1:
        bannerDisplay('19:00', '07:00');
        break;
    case 2:
        bannerDisplay('19:00', '08:00');
        break;
    case 3:
        bannerDisplay('19:00', '07:00');
        break;
    case 4:
        bannerDisplay('19:00', '08:00');
        break;
    case 5:
        bannerDisplay('19:00', '07:00');
        break;
    case 6:
        bannerDisplay('19:00', '09:00');
}

                      
function tConvert (time) {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
 if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value
    time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join (''); // return adjusted time or original string
}
  
function bannerDisplay (closetime, tmrStartTime){	    
        closetime_arr = closetime.split(':');
    	currentdate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), closetime_arr[0], closetime_arr[1]);
  
  displaytime = tConvert (closetime);
          
          if(displaytime.indexOf(':00') > -1)
          {
            displaytime = displaytime.replace(':00','');
          } 
          
          displaytime1 = tConvert (tmrStartTime);
          
          if(displaytime1.indexOf(':00') > -1)
          {
            displaytime1 = displaytime1.replace(':00','');
          }
  
    	if(currentdate.getTime() >= Date.now() ) {
        	
            $('.opening-hour-banner').text('  Open Today ' + displaytime1 + ' - ' + displaytime);
        } else {
        	
            $('.opening-hour-banner').text('  Open Tomorrow ' + displaytime1 + ' - ' + displaytime);
        }
}
    
    
$.each($('.tbl-footer tr'), function( index, tal_row ) {
  switch (index) {
    case 0:
      $(tal_row).find('td:last-child').text(tConvert('08:00') + ' - ' +  tConvert('19:00'));
      break;
    case 1:
      $(tal_row).find('td:last-child').text(tConvert('07:00') + ' - ' +  tConvert('19:00'));
      break;
    case 2:
      $(tal_row).find('td:last-child').text(tConvert('08:00') + ' - ' +  tConvert('19:00'));
      break;
    case 3:
      $(tal_row).find('td:last-child').text(tConvert('07:00') + ' - ' +  tConvert('19:00'));
      break;
    case 4:
      $(tal_row).find('td:last-child').text(tConvert('08:00') + ' - ' +  tConvert('19:00'));
      break;
    case 5:
      $(tal_row).find('td:last-child').text(tConvert('07:00') + ' - ' +  tConvert('19:00'));
      break;
    case 6:
      $(tal_row).find('td:last-child').text(tConvert('09:00') + ' - ' +  tConvert('17:00'));
  }
});
                               
});